var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMaintenance)?_c('div',{staticClass:"body-pc"},[_c('client-main'),_c('client-footer')],1):_c('div',{staticClass:"body-pc"},[_c('client-header'),_c('client-main'),_c('client-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }